// Saat dilimi seçicisinin seçenek listesi (SEM-6939).
//
// Liste ÇALIŞMA ZAMANINDAN gelir (`Intl.supportedValuesOf`), elle yazılmış bir
// diziden değil: sunucu da aynı soruyu kendi ICU tablosuna soruyor
// (`services/platform-graph/src/time-zone.ts`). Elle yazılmış bir liste iki
// yönde de bozulur — sunucunun kabul ettiği bir dilim seçicide görünmez ya da
// seçicideki bir dilim 400 ile reddedilir. tzdata da durmuyor: Europe/Kyiv
// 2022'de eklendi.
//
// Etiket dilimin kendi kısaltmasını taşır ("Europe/Istanbul (GMT+3)"). Ham
// kimlikler sıralı bir liste hâlinde okunabilir ama kullanıcı hangi saatin
// hangisi olduğunu ancak fark ile seçebiliyor.

/** Ortamın ICU tablosu erişilemezse elimizde kalan tek türetilmiş değer. */
function fallbackZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

let zones: readonly string[] | undefined;

/** Bu çalışma zamanının bildiği kanonik IANA dilimleri, alfabetik. */
export function supportedTimeZones(): readonly string[] {
  if (zones === undefined) {
    let list: string[];
    try {
      list = [...Intl.supportedValuesOf("timeZone")];
    } catch {
      list = [fallbackZone()];
    }
    // UTC listede olmayabilir ama sunucu onu her zaman kabul eder ve kiracı
    // varsayılanı bu — seçilemez olması, kiracı varsayılanına geri dönmek
    // isteyen kullanıcıyı seçeneksiz bırakırdı.
    if (!list.includes("UTC")) list.push("UTC");
    zones = list.sort((a, b) => a.localeCompare(b, "en"));
  }
  return zones;
}

const labels = new Map<string, string>();

/** "Europe/Istanbul (GMT+3)" — fark okunamazsa yalnız dilim kimliği. */
export function timeZoneLabel(zone: string, locale: string): string {
  const cacheKey = `${locale} ${zone}`;
  const cached = labels.get(cacheKey);
  if (cached !== undefined) return cached;

  let label = zone;
  try {
    const part = new Intl.DateTimeFormat(locale, {
      timeZone: zone,
      timeZoneName: "shortOffset",
    })
      .formatToParts(new Date())
      .find((candidate) => candidate.type === "timeZoneName");
    if (part !== undefined) label = `${zone} (${part.value})`;
  } catch {
    // Kimliği ICU'nun tanımadığı bir dilim etiketsiz kalır, seçici çökmez.
  }
  labels.set(cacheKey, label);
  return label;
}
